export default __webpack_public_path__ + "static/media/footer-logo.3b554ff8.webp";